// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getMetaTagServiceProvider } from "@gcg/App/Services/MetaTagProviderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { FC, useEffect } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {};

type Props = ReturnType<typeof mapStateToProps>;

const XngHeadInjector: FC<Props> = () => {
    const  generateMetaTag = async () => {
        const metaTagsArray = await getMetaTagServiceProvider();

        if (metaTagsArray.length === 0) {
            return;
        }

        metaTagsArray.forEach((metaTag:any) => {
            const meta = document.createElement("meta");
            meta.name = metaTag.name;
            meta.content = metaTag.description;
            document.head.appendChild(meta);
        });
    };

    useEffect(() => {
        generateMetaTag();
    }, []);

    return null;
};

export default connect(mapStateToProps)(XngHeadInjector);